import { TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from './map/map-preview';
import { UniversalSortFilterWrapper } from './sort-filter/universal-sort-filter';

interface FilterbarTemplateComponent extends TemplateComponent {
  config: {
    view: SortAndFiltersViewType;
  };
}

export interface FilterbarProps extends TemplateComponentProps {
  templateComponent: FilterbarTemplateComponent;
}

export const Filterbar: React.FunctionComponent<FilterbarProps> = ({ templateComponent }) => {
  const { config } = templateComponent;

  return (
    <Viewport>
      <ViewSmall>
        <Buttons withMapButton={true} dialogView={config.view} />
      </ViewSmall>
      <ViewLarge>
        <Buttons withMapButton={false} />
      </ViewLarge>
    </Viewport>
  );
};

Filterbar.displayName = 'Filterbar';

interface ButtonsProps {
  withMapButton?: boolean;
  dialogView?: SortAndFiltersViewType;
}

const Buttons = ({ withMapButton, dialogView }: ButtonsProps) => {
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();

  return (
    <UitkSpacing margin={{ small: { inline: 'three' }, medium: { inline: 'unset' }, large: { inline: 'unset' } }}>
      <UitkLayoutFlex justifyContent="space-between">
        <UitkLayoutFlexItem>
          <div>
            <UniversalSortFilterWrapper view={SortAndFiltersViewType.FILTER_BAR} />
          </div>
        </UitkLayoutFlexItem>
        {withMapButton && (
          <UitkLayoutFlexItem data-testid="map-preview-button">
            <div>
              <MapPreview viewTracker={viewTracker} tracker={tracker} dialogView={dialogView} />
            </div>
          </UitkLayoutFlexItem>
        )}
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};
